import React from "react";
import { Table } from "reactstrap";
import { SimpleRow } from "../../../../../layout/Table/SimpleRow";

function GroupDetailsTable(props) {
  const { group } = props;

  if (! group || ! group.id) {
    return <Table className="align-items-center table-flush" responsive striped>
      <tbody>
      <SimpleRow translationKey="messages.no_data" value=""/>
      </tbody>
    </Table>
  }

  return (
    <Table className="align-items-center table-flush" responsive striped>
      <tbody>
      <SimpleRow translationKey="fields.group_name" value={group.name}/>
      </tbody>
    </Table>
  );
}

export { GroupDetailsTable };
